import { URL_SEARCH_PARAMS } from "../../../app/appConstants";

export const REGISTRATION_URL_INITIAL_PARAMS = [
    URL_SEARCH_PARAMS.EMAIL,
    URL_SEARCH_PARAMS.PHONE,
];
